import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import PageNav from '../components/PageNav';
import Footer from '../components/Footer';
const faqs = [
  {q:'What is a Burner Code?',a:'A compressed, encrypted representation of your compatibility profile on a topic. It captures alignment signals without revealing raw answers.'},
  {q:'How does partner linking work?',a:'Share your Profile ID and a one-time passcode with someone. They enter both to link. Once linked, you each choose which topics to share.'},
  {q:'Can someone decode my answers?',a:'No. SIGPRINTs use one-way encoding. 14 data dimensions compressed with a 6-char Fletcher-32 checksum. Non-reversible by design.'},
  {q:'Are codes reusable across partners?',a:'No. Every partner link generates fresh pair-bound SIGPRINTs. A code from one match cannot work in another context.'},
  {q:'Do you store my data?',a:'No. All data lives on your device. No server, no database, no analytics.'},
  {q:'What topics can I fill in?',a:'The Basics, Lifestyle, Values, Intimacy, Dealbreakers, Communication, Future Plans — and more coming.'},
  {q:'What do I see when comparing?',a:'Compatibility signals per topic: Strong Match, Good Alignment, Worth Exploring. Never raw answers.'},
  {q:'Is this free?',a:'Yes. Free, no limits, no account required, no ads.'},
];
export default function FAQ() {
  const [open,setOpen]=useState(null);
  return (
    <div className="min-h-screen flex flex-col"><PageNav />
      <div className="max-w-2xl mx-auto px-4 py-12 w-full animate-fade-in">
        <h1 className="text-3xl font-bold text-gray-100 mb-2">FAQ</h1><p className="text-gray-400 mb-8">Everything you need to know.</p>
        <div className="space-y-2">
          {faqs.map((f,i)=>(
            <div key={i} className="glass overflow-hidden">
              <button onClick={()=>setOpen(open===i?null:i)} className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-white/[0.02]">
                <span className="text-sm font-medium text-gray-100 pr-4">{f.q}</span>
                <ChevronDown size={16} className={`flex-shrink-0 text-gray-500 transition-transform duration-200 ${open===i?'rotate-180':''}`}/>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${open===i?'max-h-60 opacity-100':'max-h-0 opacity-0'}`}><p className="px-5 pb-4 text-sm text-gray-400 leading-relaxed">{f.a}</p></div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
